import { CheckboxOptionInput } from '@framework/form/inputs/CheckboxOptionInput.tsx';
import { useFormItemEnabled } from '@framework/form/item/useFormItemEnabled.ts';
import clx from 'classnames';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { type IWidgetComponentOptionProps } from '../../../../IWidgetType.ts';
import { ParagraphSizeText } from '../../../common/style/ParagraphSizeText.tsx';
import { type IAdvancedMultiSelectWidget } from '../../advanced-multi-select/IAdvancedMultiSelectWidget.ts';
import { OptionLabel } from '../../common/option-list/style/OptionLabel.tsx';
import { multiSelectOptionsObjectName } from '../getMultiSelectOptionsObjectName.ts';
import { type IMultiSelectWidget } from '../IMultiSelectWidget.ts';

export interface IMultiSelectOptionPorps
  extends IWidgetComponentOptionProps<
    IMultiSelectWidget | IAdvancedMultiSelectWidget
  > {}

/**
 * Componente per la renderizzazione di un unica option del MultiSelect.
 * Nello specifico, si tratta di una checkbox.
 */
export function MultiSelectOption(props: IMultiSelectOptionPorps) {
  const { option, groupName, hideLabel } = props;

  const optionsObjectName = multiSelectOptionsObjectName(groupName);

  // Prendo dal context l'editabilità del widget "scelta multipla"
  // o comunque del parent. Se disabilitato, è disabilitato anche il figlio.
  const { visuallyDisabled: parentVisuallyDisabled } = useFormItemEnabled();

  if (!option) return;

  return (
    <CheckboxOptionInput
      readOnly={props.readonly}
      className={clx({ 'hide-label': hideLabel })}
      name={groupName}
      optionName={`${optionsObjectName}.${option.value as string}`}
      optionValue={option.value}
      disabled={parentVisuallyDisabled || option.disabled}
    >
      <OptionLabel hideLabel={hideLabel}>
        <ParagraphSizeText>
          <RichTextAdvancedRender hasCustomFont inline text={option.label} />
        </ParagraphSizeText>
      </OptionLabel>
    </CheckboxOptionInput>
  );
}
